import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ExpertiseArea} from '../../../shared/types/person/expertise-area';
import {AddExpertiseAreaService} from '../../../shared/services/expertise-area/add-expertise-area.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'wsd-add-expertise-area',
  templateUrl: './add-expertise-area.component.html',
  styleUrls: ['./add-expertise-area.component.css']
})
export class AddExpertiseAreaComponent implements OnInit {

  @Output()
  onSave = new EventEmitter<any>();

  area: ExpertiseArea;

  expertiseAreaForm: UntypedFormGroup;

  display: boolean = false;

  constructor(private addService: AddExpertiseAreaService,
              private fb: UntypedFormBuilder) {
  }

  ngOnInit() {
    this.expertiseAreaForm = this.fb.group({
      name: ['', Validators.required]
    });
    this.addService.messageSent$.subscribe(
      (expertiseArea: ExpertiseArea) => {
        this.area = expertiseArea;
        this.expertiseAreaForm.reset();
        this.expertiseAreaForm.patchValue(expertiseArea);
        this.display = true;
      }
    );
  }

  save() {
    this.expertiseAreaForm.markAsDirty();
    Object.keys(this.expertiseAreaForm.controls).forEach(key => {
      this.expertiseAreaForm.get(key).markAsDirty();
    });

    if (this.expertiseAreaForm.invalid) {
      return;
    }

    this.area.name = this.expertiseAreaForm.get('name').value;
    this.display = false;
    this.onSave.emit(this.area);
  }

  discard() {
    this.display = false;
  }

}
